import { create } from "zustand"

import { ChildTabNavOption } from "../../../types"

interface ChildTabNavStore {
  selectedTab: ChildTabNavOption
  setSelectedTab: (tab: ChildTabNavOption) => void
}

const useChildTabNavStore = create<ChildTabNavStore>((set) => ({
  selectedTab: ChildTabNavOption.PROGRESS,
  setSelectedTab: (tab) => set({ selectedTab: tab }),
}))

export default useChildTabNavStore
